import { requestOpt } from 'api'
import { Button, Input, Typography } from 'components'
import { useToast } from 'hooks'
import {
	FormLoginProps,
	LoginForm,
	OTPResponse,
	TypographyTypes
} from 'interfaces'
import React, { useEffect, useMemo, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import Cookies from 'universal-cookie'
import ModalForgotPassword from './ModalForgotPassword'

export const FormLogin: React.FC<FormLoginProps> = ({
	setBodyLogin,
	setRequestOtp,
	setIsRemember,
	setLoading,
	singin,
	setfailedAttempts
}): JSX.Element => {
	const cookies = new Cookies()
	const rememberName = cookies.get('remember_name')
	const [open, setOpen] = useState(false)
	const { showToast } = useToast()

	const {
		register,
		setValue,
		handleSubmit,
		formState: { errors }
	} = useForm<LoginForm>({
		mode: 'all'
	})
	const rules = useMemo(() => {
		return {
			email: {
				required: { value: true, message: 'This field is required' }
			},
			password: {
				required: { value: true, message: 'This field is required' }
			}
		}
	}, [])

	useEffect(() => {
		if (rememberName) {
			setValue('email', rememberName)
			setValue('remember', true)
		}
	}, [])

	const onSubmit: SubmitHandler<LoginForm> = data => {
		setLoading(true)
		if (data.remember) {
			setIsRemember(true)
		} else if (rememberName && !data.remember) {
			setIsRemember(false)
		}
		const body = {
			community_id: parseInt(process.env.REACT_APP_COMMUNITY_ID as string, 10),
			signin_type: 'email',
			signin_username: data.email,
			signin_value: data.password,
			device_type: 'web'
		}

		setBodyLogin({ ...body, otp_code: 0 })
		requestOpt(body)
			.then((response: OTPResponse | null): void => {
				setLoading(false)
				if (response?.detail) {
					if (
						response.detail ===
						'You have exceeded the limit of attempts, please contact the admin'
					)
						setfailedAttempts(3)

					showToast(response.detail, '', 'error')
					return
				}

				if (!response?.require_otp) {
					setRequestOtp(false)
					singin(body)
					return
				}
				setRequestOtp(true)
			})
			.catch(() => {
				setLoading(false)
				showToast('Something went wrong', '', 'error')
			})
	}
	return (
		<>
			<form
				className="w-[386px] h-[456px] bg-transparent-default p-6 rounded-[16px] flex flex-col justify-center items-center border-[1px] border-white"
				onSubmit={handleSubmit(onSubmit)}
				data-testid="login-form"
			>
				<Typography
					title="Welcome back!"
					fontLeading="22/27"
					type={TypographyTypes.h1}
					className="text-white mb-6"
				/>
				<Input
					name="email"
					placeholder="Email"
					type="email"
					register={register}
					rules={rules.email}
					error={errors.email}
					className="!w-full !p-[unset] mb-10"
					inputClassName="min-h-[54px] !border-none !bg-white rounded-[24px] mx-[12px]"
					borderFull={false}
					data-testid="email-input"
				/>
				<Input
					name="password"
					placeholder="Password"
					type="password"
					register={register}
					rules={rules.password}
					error={errors.password}
					className="!w-full !p-[unset] mb-10"
					inputClassName="min-h-[54px] !border-none !bg-white rounded-[24px] mx-[12px]"
					borderFull={false}
					showEye
					data-testid="password-input"
				/>
				<div className="flex justify-center items-center gap-2 w-full mb-4">
					<input
						type="checkbox"
						className="h-4 w-4 rounded border-white border-solid border-[1px] text-transparent-default bg-transparent-default cursor-pointer"
						data-testid="remember-me-checkbox"
						{...register('remember')}
					/>
					<Typography
						title="Remember me on this device"
						fontLeading="15/18"
						type={TypographyTypes.p}
						className="!font-medium text-white"
					/>
				</div>
				<Button
					label="Log in"
					type="submit"
					color="Transparent"
					className="!min-w-[unset] min-h-[54px] !w-[168px] !py-3 !px-6 !bg-white !border-[1px] border-blue-primary border-solid mb-2 text-black-1
				shadow-[0_4px_10px_rgba(255,255,255,0.5)] hover:shadow-[0_6px_15px_rgba(255,255,255,0.7)] transition-shadow duration-300 ease-in-out"
					id="logIn"
					data-testid="login-submit"
				/>
				<Button
					label="Forgot password?"
					className="!min-w-[unset] !w-max !border-none !py-4 !px-6 underline text-white"
					color="Transparent"
					onClick={() => setOpen(!open)}
					id="forgotPassword"
					data-testid="forgot-password-btn"
				/>
			</form>

			{open && <ModalForgotPassword setOpen={setOpen} open={open} />}
		</>
	)
}
